


























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { ContributionsViewType, FundingOption } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";

@Component
export default class ContributionsNavigation extends Vue {
  userStore = useUserStore();

  @Prop() activeTab: ContributionsViewType;

  ContributionsViewType = ContributionsViewType;

  navigationClicked (tabType: ContributionsViewType): void {
    this.$parent.$emit("contributions-view-change", tabType);
  }

  get displayPayrollTab (): boolean {
    return !this.userStore.isIndividualAccountType &&
    this.userStore.employeeFundingOption === FundingOption.BendCalculatePull;
  }
}
